import { useState } from 'react'
import Modal from '../../../components/Modal'
import StarRating from '../../../components/StartRating'
import Divider from '../../../components/Divider'
import talent_manager_icon from './Talent-manager.png'

const StarRatingModal = () => {
  const [rating, setRating] = useState(0)

  return (
    <Modal modalId="star-rating-modal" title="Puntuaciones">
      <div className="d-flex flex-column align-items-center justify-content-center gap-3">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="text-on-bg-primary">
            <span className="fontSize48 fw-bolder">4.3</span>
            <span className="fontSize24">/5</span>
          </div>
          <StarRating value={rating} onChange={setRating} />
           <span className="text-on-bg-secondary">25 puntuaciones</span>
        </div>
       
        <Divider className="h-1 w-100 bg-on-bg-secondary" />
        {[1, 2, 3, 4, 5, 6].map((index) => (
          <img width={337} key={index} src={talent_manager_icon} />
        ))}
      </div>
    </Modal>
  )
}

export default StarRatingModal
